import { render, staticRenderFns } from "./MPCLayout.vue?vue&type=template&id=c35e7b0c&scoped=true&"
import script from "./MPCLayout.vue?vue&type=script&lang=ts&"
export * from "./MPCLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MPCLayout.vue?vue&type=style&index=0&id=c35e7b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35e7b0c",
  null
  
)

export default component.exports